import { IPassportGroupForm } from '../interfaces/IPassportGroupForm';
import { IGroupConditionForm } from '../interfaces/IGroupConditionForm';
import { IGroupCommonConditionsForm } from '../interfaces/IGroupCommonConditionsForm';
import { IGroupStatusConditionsForm } from '../interfaces/IGroupStatusConditionsForm';
import { IGroupAssignmentConditionsForm } from '../interfaces/IGroupAssignmentConditionsForm';
import { IGroupSubjectConditionsForm } from '../interfaces/IGroupSubjectConditionsForm';
import { IGroupObjectConditionsForm } from '../interfaces/IGroupObjectConditionsForm';
import { IGroupEventConditionsForm } from '../interfaces/IGroupEventConditionsForm';
import { IGroupEventSubjectConditionsForm } from '../interfaces/IGroupEventSubjectConditionsForm';

const isEmptyCommonConditions = (condition: IGroupCommonConditionsForm | undefined): boolean => {
  if (!condition) {
    return true;
  }

  return (
    !condition.startDate &&
    !condition.endDate &&
    !condition.domains?.length &&
    !condition.knoOrganizations?.length &&
    !condition.knoOrganizationLevels?.length &&
    !condition.kindControls?.length &&
    !condition.knmTypes?.length &&
    !condition.plans?.length &&
    !condition.knmKinds?.length &&
    !condition.pmKinds?.length &&
    !condition.decisionKinds?.length &&
    !condition.reasons?.length &&
    !condition.riskIndikators?.length &&
    !condition.erpIds?.length &&
    !condition.unableToRefuse
  );
};

const isEmptyAssignmentConditions = (condition: IGroupAssignmentConditionsForm | undefined): boolean => {
  if (!condition) {
    return true;
  }

  return !condition.assigmentStartDate && !condition.assigmentEndDate && !condition.assignmentNumbers?.length;
};

const isEmptySubjectConditions = (condition: IGroupSubjectConditionsForm | undefined): boolean => {
  if (!condition) {
    return true;
  }

  return (
    !condition.subjectTypes?.length &&
    !condition.regTypes?.length &&
    !condition.mspCategories?.length &&
    !condition.checkResultStartDate &&
    !condition.checkResultEndDate
  );
};

const isEmptyObjectConditions = (condition: IGroupObjectConditionsForm | undefined): boolean => {
  if (!condition) {
    return true;
  }

  return (
    !condition.ervkNumbers?.length &&
    !condition.objectTypes?.length &&
    !condition.objectKinds?.length &&
    !condition.objectSubKinds?.length &&
    !condition.riskCategories?.length &&
    !condition.dangerClasses?.length
  );
};

const isEmptyEventSubjectConditions = (condition: IGroupEventSubjectConditionsForm | undefined): boolean => {
  if (!condition) {
    return true;
  }

  return !condition.requirements?.filter(item => item.npa).length && !condition.docTargets?.length;
};

const isEmptyEventConditions = (condition: IGroupEventConditionsForm | undefined): boolean => {
  if (!condition) {
    return true;
  }

  return !condition.eventTypes?.length;
};

const isEmptyStatusConditions = (condition: IGroupStatusConditionsForm | undefined): boolean => {
  if (!condition) {
    return true;
  }

  return !condition.statuses?.length && !condition.publishedStatus;
};

const isEmptyGroupCondition = (condition: IGroupConditionForm): boolean => {
  if (!condition.category) {
    return true;
  }

  return (
    isEmptyCommonConditions(condition.commonConditions) &&
    isEmptyAssignmentConditions(condition.assignmentConditions) &&
    isEmptySubjectConditions(condition.subjectConditions) &&
    isEmptyObjectConditions(condition.objectConditions) &&
    isEmptyEventSubjectConditions(condition.eventSubjectConditions) &&
    isEmptyEventConditions(condition.eventConditions) &&
    isEmptyStatusConditions(condition.statusConditions)
  );
};

export const getEmptyConditionName = (values: IPassportGroupForm) => {
  for (let i = 0; i < (values.includes?.length || 0); i += 1) {
    const condition = values.includes?.[i];

    if (!condition || isEmptyGroupCondition(condition)) {
      return `includes[${i}]`;
    }
  }

  for (let i = 0; i < (values.exceptions?.length || 0); i += 1) {
    const condition = values.exceptions?.[i];

    if (!condition || isEmptyGroupCondition(condition)) {
      return `exceptions[${i}]`;
    }
  }
};
